enum SpotlightStatsEnum {
  USER_MOST_SONGS = "topUsersByVideos",
  USER_MOST_LIKES = "topUsersByLikes",
  SONG_MOST_LIKES = "topLikedVideos",
}

export default SpotlightStatsEnum;
